import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.regexp.flags.js";

/* eslint-disable */
import './cadesplugin_api';

window.CryptoHelper = function () {
  const self = this;
  const crypto = window.cadesplugin;
  const SIGN_DETACHED = true;
  const VERBOSE = true;
  self.isReady = false;
  self.readyPromise = null;
  self.check_is_certificate_valid_when_parsing = true;

  this.setCheckCertificateValidWhenParsing = value => {
    self.check_is_certificate_valid_when_parsing = value;
  };
  /**
   * Handle plugin init event
   * @returns {Promise}
   */


  this.init = () => {
    if (self.readyPromise) return self.readyPromise;
    self.readyPromise = new Promise((resolve, reject) => {
      crypto.then(async () => {
        if (await check()) {
          resolve();
        } else {
          reject(new Error('Не удалось активировать плагин КриптоПро CSP'));
        }
      }).catch(e => {
        reject(e);
      });
    });
    return self.readyPromise;
  };
  /**
   * Get valid certificates from store
   * @param {Number} location location of the store to be opened
   * @param {String} storeName a string that contains the name of the system certificate store to be opened
   * @param {Number} mode open mode of the store
   * @returns {Array<Certificate>}
   */


  this.getCertificates = (location, storeName, mode) => {
    const _location = location || crypto.CAPICOM_CURRENT_USER_STORE;

    const _storeName = storeName || crypto.CAPICOM_MY_STORE;

    const _mode = mode || crypto.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED;

    return new Promise(async resolve => {
      const store = await createStore();
      store.Open(_location, _storeName, _mode);
      let certs = await store.Certificates; //certs = await certs.Find(crypto.CAPICOM_CERTIFICATE_FIND_TIME_VALID);

      const certificates = [];

      for (let i = 1; i <= (await certs.Count); i += 1) {
        const cert = await certs.Item(i);
        certificates.push(await parseCertificate(cert));
      }

      store.Close();
      resolve(certificates);
    });
  };
  /**
   * Sign various data type by chosen certificate
   * @param {Certificate} certificate
   * @param {String|File|DomElement} data
   * @returns {String}
   */


  this.sign = (certificate, data) => {
    if (data instanceof File) {
      log('[Crypto] Signing File');
      return this.signFile(certificate, data);
    } else if (data instanceof FileList) {
      log('[Crypto] Signing FileList');
      return this.signFileList(certificate, data);
    } else if (data instanceof HTMLInputElement && data.type === 'file') {
      log('[Crypto] Signing file input');
      return this.signFileList(certificate, data.files);
    } else {
      log('[Crypto] Signing string');
      return this.signString(certificate, data);
    }
  };

  function readFileAsync(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  this.signLargeFile = async (cert, file, onProgress) => {
    const oCertificate = cert.$original || cert;
    let oHashedData = await crypto.CreateObjectAsync("CAdESCOM.HashedData");
    await oHashedData.propset_DataEncoding(window.cadesplugin.CADESCOM_BASE64_TO_BINARY);
    await oHashedData.propset_Algorithm(this.getHashAlgNumber(cert));
    const header = ";base64,";
    let currentChunk = 0;
    const chunkSize = 3 * 1024 * 1024;
    let fileReader = new FileReader();

    while (true) {
      const start = currentChunk * chunkSize;
      let end = currentChunk * chunkSize + chunkSize;
      if (end >= file.size) end = undefined;
      let res = await readFileAsync(file.slice(start, end));
      const sBase64Data = res.substr(res.indexOf(header) + header.length);
      oHashedData.Hash(sBase64Data);
      if (end === undefined) break;
      currentChunk++;
      const percentLoaded = Math.round(end / file.size * 100);
      if (onProgress) onProgress(percentLoaded);
    }

    if (onProgress) onProgress(100);
    const oSigner = await createSigner();
    oSigner.propset_Certificate(oCertificate);
    oSigner.propset_Options(window.cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN); //тут надо указать нормальный адрес TSP сервера. Это тестовый от Крипто ПРО
    //oSigner.propset_TSAAddress("http://tax4.tensor.ru/tsp-tensor_gost2012/tsp.srf");
    //oSigner.propset_TSAAddress("https://www.cryptopro.ru/tsp/");

    let oSignedData = await createSignedData();
    oSignedData.propset_ContentEncoding(window.cadesplugin.CADESCOM_BASE64_TO_BINARY); //результат подписания в base64
    // Если надо с штампом времени, то вместо CADESCOM_PKCS7_TYPE надо юзать CADESCOM_CADES_X_LONG_TYPE_1,
    // но и тогда нужно указывать валидный сервер времени через oSigner.propset_TSAAddress('http://????');

    return await oSignedData.SignHash(oHashedData, oSigner, window.cadesplugin.CADESCOM_PKCS7_TYPE);
  };
  /**
   * Sign hash by chosen certificate
   * @param {Certificate} certificate
   * @param {String} $hash
   * @param {Boolean} toBase64
   * @returns {String}
   */


  this.signHash = (Certificate, $hash, toBase64) => {
    return new Promise((resolve, reject) => {
      try {
        window.cadesplugin.async_spawn(function* () {
          let oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
          oSigner.propset_Certificate(Certificate.$original);
          oSigner.propset_Options(window.cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN); //тут надо указать нормальный адрес TSP сервера. Это тестовый от Крипто ПРО
          //oSigner.propset_TSAAddress("http://tax4.tensor.ru/tsp-tensor_gost2012/tsp.srf");
          //oSigner.propset_TSAAddress("https://www.cryptopro.ru/tsp/");

          let hashObject = yield window.cadesplugin.CreateObjectAsync("CAdESCOM.HashedData");
          yield hashObject.propset_Algorithm(self.getHashAlgNumber(Certificate)); //в объект описания hash вставляем уже готовый hash с сервера

          yield hashObject.SetHashValue($hash);
          let oSignedData = yield window.cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");
          oSignedData.propset_ContentEncoding(window.cadesplugin.CADESCOM_BASE64_TO_BINARY); //результат подписания в base64
          // Если надо с штампом времени, то вместо CADESCOM_PKCS7_TYPE надо юзать CADESCOM_CADES_X_LONG_TYPE_1,
          // но и тогда нужно указывать валидный сервер времени через oSigner.propset_TSAAddress('http://????');

          let signatureHex;

          try {
            signatureHex = yield oSignedData.SignHash(hashObject, oSigner, window.cadesplugin.CADESCOM_PKCS7_TYPE);
          } catch (e) {
            reject(e);
            return;
          }

          let $signature = signatureHex;
          resolve($signature);
        });
      } catch (exc) {
        reject(exc);
      }
    });
  };
  /**
   * Sign string data by chosen certificate
   * @param {Certificate} certificate
   * @param {String} data
   * @param {Boolean} toBase64
   * @returns {Promise}
   */


  this.signString = (certificate, data, toBase64 = true) => {
    return new Promise(async (resolve, reject) => {
      try {
        const signer = await createSigner();
        const signedData = await createSignedData();
        await signer.propset_Certificate(certificate.$original || certificate);
        await signer.propset_Options(crypto.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN);
        await signedData.propset_ContentEncoding(crypto.CADESCOM_BASE64_TO_BINARY);
        await signedData.propset_Content(toBase64 ? utf8_to_b64(data) : data);
        const signedMessage = await signedData.SignCades(signer, crypto.CADESCOM_CADES_BES, SIGN_DETACHED);
        resolve(signedMessage);
      } catch (e) {
        e.source = 'cryptopro';
        console.error('[Crypto] Sign failed', e);
        reject(e);
      }
    });
  };

  function utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  function b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
  }
  /**
   * Sign XML string
   * @param {Certificate} certificate
   * @param {String} xmlString
   * @param {Number} SignatureType
   * */


  this.signXML = async (certificate, xmlString, SignatureType = 0) => {
    var _certificate$$origina;

    const oCert = (_certificate$$origina = certificate === null || certificate === void 0 ? void 0 : certificate.$original) !== null && _certificate$$origina !== void 0 ? _certificate$$origina : certificate;
    const publicKey = await oCert.PublicKey();
    const algorithm = await publicKey.Algorithm;
    const value = await algorithm.Value;
    const oSigner = await createSigner();
    await oSigner.propset_Certificate(oCert);
    const signedXml = await createSignedXML();
    const {
      signAlgorithm,
      hashAlgorithm
    } = doXmlSignatureAlgorithm(value);
    await signedXml.propset_Content(xmlString);
    await signedXml.propset_SignatureType(SignatureType); // Тип подписи: https://cpdn.cryptopro.ru/content/cades/namespace_c_ad_e_s_c_o_m_bc786984157586e73c5fca967d9da4ef_1bc786984157586e73c5fca967d9da4ef.html

    await signedXml.propset_SignatureMethod(signAlgorithm);
    await signedXml.propset_DigestMethod(hashAlgorithm);
    return await signedXml.Sign(oSigner);
  };
  /**
   * @function doXmlSignatureAlgorithm
   * @param {String} value алгоритм сертификата
   * @returns {Object}
   * @throws {Error}
   * @description определяет алгоритм подписания XML документа в зависимости от алгоритма сертификата
   */


  function doXmlSignatureAlgorithm(value) {
    switch (value) {
      case '1.2.643.2.2.19':
        // алгоритм ГОСТ Р 34.10-2001
        return template('urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102001-gostr3411')('urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr3411');

      case '1.2.643.7.1.1.1.1':
        // алгоритм ГОСТ Р 34.10-2012 256 бит
        return template('urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-256')('urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-256');

      case '1.2.643.7.1.1.1.2':
        // алгоритм ГОСТ Р 34.10-2012 512 бит
        return template('urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-512')('urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-512');

      default:
        throw new Error('Сертификат не соответствует ГОСТ Р 34.10-2012 (256 или 512 бит) или ГОСТ Р 34.10-2001');
    }
  }
  /**
   * @function template
   * @param {String} signAlgorithm алгоритм подписи
   */


  function template(signAlgorithm) {
    /**
     * @function doHashAlgorithm
     * @param {String} hashAlgorithm алгоритм хэширования
     */
    return function doHashAlgorithm(hashAlgorithm) {
      return {
        signAlgorithm,
        hashAlgorithm
      };
    };
  }
  /**
   * Sign file by chosen certificate
   * @param {Certificate} certificate
   * @param {File} file
   * @returns {String}
   */


  this.signFile = (certificate, file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        const header = ';base64,';
        const fileData = reader.result;
        const fileContent = fileData.substr(fileData.indexOf(header) + header.length);
        this.signString(certificate, fileContent, false).then(data => {
          resolve(data);
        }).catch(err => {
          err.source = 'cryptopro';
          reject(err);
        });
      };
    });
  };
  /**
   * Sign file list by chosen certificate
   * @param {Certificate} certificate
   * @param {FileList} fileList
   * @returns {Array<String>}
   */


  this.signFileList = (certificate, fileList) => {
    const promises = Array.from(fileList).map(file => {
      return this.signFile(certificate, file);
    });
    return Promise.all(promises);
  };

  this.parseSignInfo = SignedData => {
    return signInfo(SignedData);
  };
  /**
   * Verify data sign
   * @param {String} data
   * @param {String} sign
   * @param {Boolean} toBase64
   * @returns {Array<Object>}
   */


  this.verify = (data, sign, toBase64 = false) => {
    return new Promise(async (resolve, reject) => {
      const signedData = await createSignedData();
      signedData.propset_ContentEncoding(crypto.CADESCOM_BASE64_TO_BINARY);
      signedData.propset_Content(toBase64 ? utf8_to_b64(data) : data);

      try {
        await signedData.VerifyCades(sign, crypto.CADESCOM_CADES_BES, true);
        const signs = await signInfo(signedData);
        resolve(signs);
      } catch (e) {
        e.signs_info = await signInfo(signedData);
        console.error('[Crypto] Verify failed', e);
        reject(e);
      }
    });
  };

  this.verifyXmlSigns = async (xmlString, xpath) => {
    const oSignedXML = await createSignedXML();

    try {
      if (xpath) {
        await oSignedXML.Verify(xmlString, xpath);
      } else {
        await oSignedXML.Verify(xmlString);
      }
    } catch (e) {
      return e;
    }

    return this.parseSignInfo(oSignedXML);
  };
  /**
   * Get installed CSP version
   */


  this.checkCSP = () => {
    return new Promise(async (resolve, reject) => {
      try {
        let oAbout = await crypto.CreateObjectAsync('CAdESCOM.About');
        let oVersion = await oAbout.CSPVersion();
        const about = {
          version: await oVersion.toString(),
          name: await oAbout.CSPName()
        };
        resolve(about);
      } catch (e) {
        reject();
      }
    });
  };
  /**
   * Check cadesplugin is ready
   * (try create Store object)
   */


  async function check() {
    try {
      await createStore();
      return self.isReady = true;
    } catch (e) {
      return self.isReady = false;
    }
  }
  /**
   * Create new CAdESCOM.Store instance
   * View more at https://cpdn.cryptopro.ru/content/cades/class_store.html
   * @returns {CAdESCOM.Store}
   */


  async function createStore() {
    return await crypto.CreateObjectAsync('CAdESCOM.Store');
  }
  /**
   * Create new CAdESCOM.CPSigner instance
   * View more at https://cpdn.cryptopro.ru/content/cades/class_c_ad_e_s_c_o_m_1_1_c_p_signer.html
   * @returns {CAdESCOM.CPSigner}
   */


  async function createSigner() {
    return await crypto.CreateObjectAsync('CAdESCOM.CPSigner');
  }
  /**
   * Create new CAdESCOM.SignedXML instance
   * @returns {CAdESCOM.SignedXML}
   */


  async function createSignedXML() {
    return await crypto.CreateObjectAsync('CAdESCOM.SignedXML');
  }
  /**
   * Create new CAdESCOM.CadesSignedData instance
   * View more at https://cpdn.cryptopro.ru/content/cades/class_c_ad_e_s_c_o_m_1_1_cades_signed_data.html
   * @returns {CAdESCOM.CadesSignedData}
   */


  async function createSignedData() {
    return await crypto.CreateObjectAsync('CAdESCOM.CadesSignedData');
  }
  /**
   * Extract certificate subject info
   * @param {Certificate} certificate
   * @returns {Object}
   */


  async function extractSubjectName(certificate) {
    var subject = await certificate.SubjectName;
    return parseDN(subject);
  }
  /**
   * Extract certificate issuer info
   * @param {Certificate} certificate
   * @return {Object}
   */


  async function extractIssuerName(certificate) {
    var issuer = await certificate.IssuerName;
    return parseDN(issuer);
  }
  /**
   * Extract certificate Public Key info
   * @param {Certificate} certificate
   * @return {Object}
   */


  async function extractCerPublicKey(certificate) {
    let PublicKey = await certificate.PublicKey();
    let Algorithm = await PublicKey.Algorithm;
    let AlgorithmValue = await Algorithm.Value;
    let AlgorithmFriendlyName = await Algorithm.FriendlyName; //console.log(Algorithm);

    return {
      Algorithm: {
        value: AlgorithmValue,
        FriendlyName: AlgorithmFriendlyName
      }
    };
  }

  this.getHashAlg = certificate => {
    if (certificate['publicKey']) {
      switch (certificate.publicKey.Algorithm.value) {
        case '1.2.643.7.1.1.1.1':
          return '1.2.643.7.1.1.2.2';

        case '1.2.643.7.1.1.1.2':
          return '1.2.643.7.1.1.2.3';

        case '1.2.643.2.2.20':
          return '1.2.643.2.2.9';

        default:
          return false;
      }
    }

    return false;
  };

  this.dnKeyToString = dn => {
    switch (dn) {
      case 'name':
        return 'Имя';

      case 'company':
        return 'Организация';

      case 'person_surname':
        return 'Фамилия';

      case 'person_name':
        return 'Имя отчество';

      case 'country':
        return 'Страна';

      case 'region':
        return 'Область';

      case 'city':
        return 'Город';

      case 'ogrn':
        return 'ОГРН';

      case 'inn':
        return 'ИНН';

      case 'email':
        return 'Почта';

      case 'postType':
        return 'Подразделение';

      case 'post':
        return 'Должность';

      case 'address':
        return 'Адрес';

      case 'snils':
        return 'СНИЛС';

      case 'INNLE':
        return 'ИНН юридического лица';

      default:
        return dn;
    }
  };

  this.getHashAlgNumber = certificate => {
    if (certificate['publicKey']) {
      switch (certificate.publicKey.Algorithm.value) {
        case '1.2.643.7.1.1.1.1':
          return 101;
        // CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256

        case '1.2.643.7.1.1.1.2':
          return 102;
        //CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512

        case '1.2.643.2.2.20':
          return 100;
        // CADESCOM_HASH_ALGORITHM_CP_GOST_3411

        default:
          return false;
      }
    }

    return false;
  };
  /**
   * Extract certificate Public Key info
   * @param {Certificate} certificate
   * @return {Object}
   */


  async function extractCerPrivateKey(certificate) {
    let $HasPrivateKey = await certificate.HasPrivateKey();

    if ($HasPrivateKey) {
      let PrivateKey = await certificate.PrivateKey;
      let PrivateProviderName = await PrivateKey.ProviderName;
      let ProviderType = await PrivateKey.ProviderType;
      let KeySpec = await PrivateKey.KeySpec; //console.log(PrivateKey);

      return {
        ProviderName: PrivateProviderName,
        ProviderType: ProviderType,
        KeySpec: KeySpec
      };
    } else {
      return false;
    }
  }
  /**
   * Extract certificate info
   * @param {Certificate} certificate
   * @returns {Object}
   */


  async function parseCertificate(certificate) {
    const isValid = self.check_is_certificate_valid_when_parsing ? (await certificate.IsValid()).Result : true;
    return {
      $original: certificate,
      subject: await extractSubjectName(certificate),
      issuer: await extractIssuerName(certificate),
      version: await certificate.Version,
      serialNumber: await certificate.SerialNumber,
      thumbprint: await certificate.Thumbprint,
      validFrom: await certificate.ValidFromDate,
      validTo: await certificate.ValidToDate,
      hasPrivate: await certificate.HasPrivateKey(),
      isValid: isValid,
      publicKey: await extractCerPublicKey(certificate),
      PrivateKey: await extractCerPrivateKey(certificate)
    };
  }
  /**
   * Extract signers from SignedData object
   * @param {CAdESCOM.CadesSignedData} signedData
   * @returns {Array<Object>}
   */


  async function signInfo(signedData) {
    const signers = await signedData.Signers;
    const count = await signers.Count;
    const signs = [];

    for (let i = 1; i <= count; i += 1) {
      const signer = await signers.Item(i);
      const certificate = await signer.Certificate;
      let ts;

      try {
        ts = await signer.SigningTime;
      } catch (e) {//console.log(e);
      }

      const sign = {
        ts: ts,
        cert: await parseCertificate(certificate)
      };
      signs.push(sign);
    }

    return signs;
  }
  /**
   * Parse DN string to object
   * @param {String} dn
   * @returns {Object}
   */


  function parseDN(dn) {
    //console.log(dn);
    const tags = {
      'C': 'country',
      'Е': 'email',
      'CN': 'name',
      'SN': 'person_surname',
      'G': 'person_name',
      'S': 'region',
      'STREET': 'address',
      'O': 'company',
      'OU': 'postType',
      'T': 'post',
      'ОГРН': 'ogrn',
      'СНИЛС': 'snils',
      'ИНН': 'inn',
      'E': 'email',
      'L': 'city',
      'OID.1.2.643.100.4': 'INNLE',
      'ИНН ЮЛ': 'INNLE'
    };
    let buf = dn;
    /*const fields = [...buf.matchAll(/(\w+)=/g)].reduceRight((acc, cur) => {
        let v = buf.substring(cur.index);
        v = v.replace(cur[0], '');
        v = v.replace(/\s*"?(.*?)"?,?\s?$/, '$1');
        v = v.replace(/""/g, '"');
          const tag = cur[1];
          if (tags[tag]) {
            acc[tags[tag]] = v;
        } else {
            acc[tag] = v;
        }
          buf = buf.substring(0, cur.index);
          return acc;
    }, {});*/

    let fields = {};
    let tmp = [...buf.matchAll(/([a-zA-ZА-Яа-я ]+?=|OID[.\d]+?=)/gi)];
    let $prevItem = null;
    tmp.map($item => {
      if ($prevItem) {
        let $item_index = $prevItem[0].substring(0, $prevItem[0].length - 1).trim();
        let $item_value = buf.substr($prevItem[0].length + $prevItem.index, $item.index - $prevItem.index - $prevItem[0].length).trim().slice(0, -1).trim();

        if (tags[$item_index]) {
          fields[tags[$item_index]] = $item_value;
        } else {
          fields[$item_index] = $item_value;
        }
      }

      $prevItem = $item;
    });
    let $item_index = $prevItem[0].substring(0, $prevItem[0].length - 1).trim();
    let $item_value = buf.substr($prevItem[0].length + $prevItem.index).trim();

    if (tags[$item_index]) {
      fields[tags[$item_index]] = $item_value;
    } else {
      fields[$item_index] = $item_value;
    }

    return fields;
  }
  /**
   * Write verbose message to console
   * @param  {...any} args
   */


  function log(...args) {
    if (VERBOSE) {
      console.log(...args);
    }
  }
};
/**
 * String.matchAll polyfill
 */


if (!String.prototype.matchAll) {
  String.prototype.matchAll = function* (regex) {
    function ensureFlag(flags, flag) {
      return flags.includes(flag) ? flags : flags + flag;
    }

    const localRegex = new RegExp(regex, ensureFlag(regex.flags, 'g'));
    let match;

    while (match = localRegex.exec(this)) {
      yield match;
    }
  };
}

window.cp = new window.CryptoHelper();
export default new window.CryptoHelper();